export const tool = {
  name: 'end-session',
  description:
    'A tool that handles ending the user session gracefully when the user says goodbye or wants to exit.',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      reason: {
        type: 'string',
        description:
          'Optional reason for ending the session (e.g., user said bye, session timeout).',
      },
      message: {
        type: 'string',
        default: 'Session ended successfully.',
      },
    },
    required: ['message'],
  },
};
